export default __webpack_public_path__ + "static/media/default.68bc34193217e46086c5cb200c4b890f.png";